import { createSelector } from "reselect";
import { populationTalliesByLocationSelector } from "../population_tallies_by_location_selector";

export const populationTalliesByLocationDataSelector = createSelector(
  populationTalliesByLocationSelector,
  tallies => {
    return tallies.data;
  }
);
